const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins

class DrawerCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: this.displayedCardsMobile,
          spacing: this.spacing,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: this.displayedCardsDesktop,
              spacing: this.spacing,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  get spacing () {
    return Number(this.dataset.spacing) || 1
  }

  get displayedCardsMobile () {
    return Number(this.dataset.slidesMobile) || 'auto'
  }

  get displayedCardsDesktop () {
    return Number(this.dataset.slidesDesktop) || this.displayedCardsMobile
  }
}

if (!customElements.get('drawer-carousel')) {
  customElements.define('drawer-carousel', DrawerCarousel)
}
